// extracted by mini-css-extract-plugin
module.exports = {"overlay":"loader_overlay__3fYnn","loader":"loader_loader__vPvVg","loader1":"loader_loader1__3UheO","loader2":"loader_loader2__35mdR","loader3":"loader_loader3__3ANfu"};